class AZTable extends HTMLElement {
    constructor() {
        super();

        this.azTable = document.getElementById('haloAZTable');
        this.azWrapper = document.getElementById('haloAZWrapper');
        this.mapPopup = document.getElementById('halo-map-popup');

        if(!this.azTable || !this.azWrapper) return;


        // Run once on page load
        this.runFromHash();

        if(this.azTable.querySelector('a')){
	        this.azTable.querySelectorAll('a').forEach((azButton) => {
	        	azButton.addEventListener('click', this.onClickHandler.bind(this));
	        });
	    }

	    if(this.azWrapper.querySelector('[data-open-map-popup]')){
	        this.azWrapper.querySelectorAll('[data-open-map-popup]').forEach((mapButton) => {
	        	mapButton.addEventListener('click', this.onClickOpenMap.bind(this));
	        });
	    }

	    if(document.querySelector('[data-close-map-popup]')){
	    	document.querySelector('[data-close-map-popup]').addEventListener(
                'click',
                this.onClickCloseMap.bind(this)
            );
	    }

	    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

              // Listen for manual hash changes
        this.onHashChange = this.onHashChange.bind(this);
        window.addEventListener('hashchange', this.onHashChange);
    }

 // Run hash logic on page load or manual change
    runFromHash() {
        const hash = window.location.hash;
        if (hash.startsWith('#az-code-')) {
            const letter = hash.replace('#az-code-', '').toLowerCase();
            this.activateLetter(letter);
        } else if (hash === '#' || hash === '') {
            // Select All
            this.activateLetter(null);
        }
    }

    onHashChange() {
    this.runFromHash();
        // Optional: remove listener after first run if you want
        // window.removeEventListener('hashchange', this.onHashChange);
    }

    onClickHandler(event) {
        event.preventDefault();

        // this.azTable.querySelectorAll('li').forEach((element) =>{
        // 	element.classList.remove('is-active');
        // });

        // event.target.closest('li').classList.add('is-active');

        // var letter = event.target.getAttribute('data-href').toLowerCase();

        // this.azWrapper.querySelectorAll('.az-group').forEach((element) =>{
        // 	element.classList.remove('is-active');
        // });

        // if (letter != undefined && letter != null) {
        //     this.azWrapper.classList.remove('active-all');
        //     this.azWrapper.querySelector(`[data-letter="${letter}"]`).classList.add('is-active');
        // } else {
        //     this.azWrapper.classList.add('active-all');
        // }
              const link = event.target.closest('a');
        if (!link) return;

        const letter = link.getAttribute('data-href')?.toLowerCase();

  // Update URL hash
    if (letter) {
        history.replaceState(null, null, `#az-code-${letter.toLowerCase()}`);
    } else {
        history.replaceState(null, null, '#'); // Select All
    }

        this.activateLetter(letter);
    }

    activateLetter(letter) {
    this.azTable.querySelectorAll('li').forEach(el => el.classList.remove('is-active'));
    this.azWrapper.querySelectorAll('.az-group').forEach(el => el.classList.remove('is-active'));

    if (letter) {
        // Activate specific letter
        const li = this.azTable.querySelector(`a[data-href="${letter.toUpperCase()}"]`)?.closest('li');
        if (li) li.classList.add('is-active');

        const target = this.azWrapper.querySelector(`[data-letter="${letter.toLowerCase()}"]`);
        if (target) this.azWrapper.classList.remove('active-all'); target.classList.add('is-active');
    } else {
        // "Select All" case
        this.azWrapper.classList.add('active-all');
    }
}

    onClickOpenMap(event){
    	event.preventDefault();
        event.stopPropagation();

        let url = event.target.getAttribute('data-href'),
            title = event.target.getAttribute('data-title'),
            content = `<iframe src="${url}" width="100%" height="500" style="border:0;" allowfullscreen=""></iframe>`;

    	this.mapPopup.querySelector('.halo-popup-title').innerText = title;
    	this.mapPopup.querySelector('.map').innerHTML = content;

    	document.body.classList.add('map-popup-show');
    }

    onClickCloseMap(event){
        document.body.classList.remove('map-popup-show');
    }

    onBodyClickEvent(event){
        if(document.body.classList.contains('map-popup-show')){
            if ((!this.mapPopup.contains(event.target)) && (!(event.target).closest('[data-open-map-popup]'))){
                this.onClickCloseMap();
            }
        }
    }
}

customElements.define('aztable-items', AZTable);